// Clinical design tokens — single source of truth, mirrors D1 in direction-1.jsx.
export const colors = {
  ink: '#0B1220',
  ink2: '#1E293B',
  muted: '#64748B',
  dim: '#94A3B8',
  hair: '#E5E7EB',
  hair2: '#F1F5F9',
  bg: '#FAFAF7',
  surface: '#FFFFFF',
  blue: '#2563EB',
  blueLight: '#3B82F6',
  blueSoft: '#EFF6FF',
  ember: '#C2410C',
} as const;

export const font = {
  sans: '"Inter Tight", Inter, -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
  mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
} as const;
